export default __webpack_public_path__ + "static/media/sub-banner-num-2-hover.93e5c801.svg";